(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("postRobot", [], factory);
	else if(typeof exports === 'object')
		exports["postRobot"] = factory();
	else
		root["postRobot"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 31);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(21);

Object.keys(_config).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _config[key];
    }
  });
});

var _constants = __webpack_require__(10);

Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _constants[key];
    }
  });
});

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.global = undefined;

var _conf = __webpack_require__(0);

var global = exports.global = window[_conf.CONSTANTS.WINDOW_PROPS.POSTROBOT] = window[_conf.CONSTANTS.WINDOW_PROPS.POSTROBOT] || {};

// Backwards compatibility

global.registerSelf = function () {
    // pass
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__(14);

Object.keys(_promise).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _promise[key];
    }
  });
});

var _util = __webpack_require__(3);

Object.keys(_util).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _util[key];
    }
  });
});

var _log = __webpack_require__(8);

Object.keys(_log).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _log[key];
    }
  });
});

var _windows = __webpack_require__(6);

Object.keys(_windows).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _windows[key];
    }
  });
});

var _methods = __webpack_require__(25);

Object.keys(_methods).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _methods[key];
    }
  });
});

var _tick = __webpack_require__(15);

Object.keys(_tick).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _tick[key];
    }
  });
});

var _ready = __webpack_require__(26);

Object.keys(_ready).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ready[key];
    }
  });
});

var _domain = __webpack_require__(13);

Object.keys(_domain).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _domain[key];
    }
  });
});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.once = once;
exports.noop = noop;
exports.safeHasProp = safeHasProp;
exports.safeGetProp = safeGetProp;
exports.listen = listen;
exports.apply = apply;
exports.find = find;
exports.map = map;
exports.some = some;
exports.keys = keys;
exports.values = values;
exports.getByValue = getByValue;
exports.uniqueID = uniqueID;
exports.memoize = memoize;
exports.extend = extend;
exports.each = each;
exports.replaceObject = replaceObject;
exports.safeInterval = safeInterval;
exports.intervalTimeout = intervalTimeout;
exports.getActualDomain = getActualDomain;
exports.getDomain = getDomain;
exports.getDomainFromUrl = getDomainFromUrl;
exports.safeGet = safeGet;
exports.isRegex = isRegex;
exports.weakMapMemoize = weakMapMemoize;

var _src = __webpack_require__(4);

var _conf = __webpack_require__(0);

function once(method) {
    if (!method) {
        return method;
    }
    var called = false;
    return function onceWrapper() {
        if (!called) {
            called = true;
            return method.apply(this, arguments);
        }
    };
}

function noop() {
    // pass
}

function safeHasProp(obj, name) {
    try {
        if (obj[name]) {
            return true;
        } else {
            return false;
        }
    } catch (err) {
        return false;
    }
}

function safeGetProp(obj, name) {
    try {
        return obj[name];
    } catch (err) {
        return;
    }
}

function listen(win, event, handler) {
    if (win.addEventListener) {
        win.addEventListener(event, handler);
    } else {
        win.attachEvent('on' + event, handler);
    }

    return {
        cancel: function cancel() {
            if (win.removeEventListener) {
                win.removeEventListener(event, handler);
            } else {
                win.detachEvent('on' + event, handler);
            }
        }
    };
}

function apply(method, context, args) {
    if (typeof method.apply === 'function') {
        return method.apply(context, args);
    }
    return method(args[0], args[1], args[2], args[3], args[4], args[5], args[6], args[7], args[8], args[9]);
}

function find(collection, method, def) {
    if (!collection) {
        return def;
    }
    for (var i = 0; i < collection.length; i++) {
        if (method(collection[i])) {
            return collection[i];
        }
    }
    return def;
}

function map(collection, method) {
    var results = [];
    for (var i = 0; i < collection.length; i++) {
        results.push(method(collection[i]));
    }
    return results;
}

function some(collection, method) {
    method = method || Boolean;
    for (var i = 0; i < collection.length; i++) {
        if (method(collection[i])) {
            return true;
        }
    }
    return false;
}

function keys(mapping) {
    var result = [];
    for (var key in mapping) {
        if (mapping.hasOwnProperty(key)) {
            result.push(key);
        }
    }
    return result;
}

function values(mapping) {
    var result = [];
    for (var key in mapping) {
        if (mapping.hasOwnProperty(key)) {
            result.push(mapping[key]);
        }
    }
    return result;
}

function getByValue(mapping, value) {
    for (var key in mapping) {
        if (mapping.hasOwnProperty(key) && mapping[key] === value) {
            return key;
        }
    }
}

function uniqueID() {

    var chars = '0123456789abcdef';

    return 'xxxxxxxxxx'.replace(/./g, function () {
        return chars.charAt(Math.floor(Math.random() * chars.length));
    });
}

function memoize(method) {

    var results = {};

    return function memoized() {
        var args = JSON.stringify(Array.prototype.slice.call(arguments));
        if (!results.hasOwnProperty(args)) {
            results[args] = method.apply(this, arguments);
        }
        return results[args];
    };
}

function extend(obj, source) {
    if (!source) {
        return obj;
    }

    for (var key in source) {
        if (source.hasOwnProperty(key)) {
            obj[key] = source[key];
        }
    }

    return obj;
}

function each(obj, callback) {
    if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; i++) {
            callback(obj[i], i);
        }
    } else if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null) {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                callback(obj[key], key);
            }
        }
    }
}

function replaceObject(obj, callback) {
    var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;


    if (depth >= 100) {
        throw new Error('Self-referential object passed, or object contained too many layers');
    }

    var newobj = Array.isArray(obj) ? [] : {};

    each(obj, function (item, key) {

        var result = callback(item, key);

        if (result !== undefined) {
            newobj[key] = result;
        } else if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null) {
            newobj[key] = replaceObject(item, callback, depth + 1);
        } else {
            newobj[key] = item;
        }
    });

    return newobj;
}

function safeInterval(method, time) {
    var timeout = void 0;

    function runInterval() {
        timeout = setTimeout(runInterval, time);
        method.call();
    }

    timeout = setTimeout(runInterval, time);

    return {
        cancel: function cancel() {
            clearTimeout(timeout);
        }
    };
}

function intervalTimeout(time, interval, method) {

    var _safeInterval = safeInterval(function () {
        time -= interval;

        time = time <= 0 ? 0 : time;

        if (time === 0) {
            _safeInterval.cancel();
        }

        method(time);
    }, interval);

    return safeInterval;
}

function getActualDomain(win) {
    return win.location.protocol + '//' + win.location.host;
}

function getDomain(win) {

    win = win || window;

    if (win.mockDomain && win.mockDomain.indexOf(_conf.CONSTANTS.MOCK_PROTOCOL) === 0) {
        return win.mockDomain;
    }

    if (!win.location.protocol) {
        throw new Error('Can not read window protocol');
    }

    if (win.location.protocol === _conf.CONSTANTS.FILE_PROTOCOL) {
        return getActualDomain(win);
    }

    if (!win.location.host) {
        throw new Error('Can not read window host');
    }

    return getActualDomain(win);
}

function getDomainFromUrl(url) {

    var domain = void 0;

    if (url.match(/^(https?|mock|file):\/\//)) {
        domain = url;
    } else {
        return getDomain();
    }

    domain = domain.split('/').slice(0, 3).join('/');

    return domain;
}

function safeGet(obj, prop) {

    var result = void 0;

    try {
        result = obj[prop];
    } catch (err) {
        // pass
    }

    return result;
}

function isRegex(item) {
    return Object.prototype.toString.call(item) === '[object RegExp]';
}

function weakMapMemoize(method) {

    var weakmap = new _src.WeakMap();

    return function (arg) {
        var result = weakmap.get(arg);

        if (typeof result !== 'undefined') {
            return result;
        }

        result = method.call(this, arg);

        if (typeof result !== 'undefined') {
            weakmap.set(arg, result);
        }

        return result;
    };
}

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _interface = __webpack_require__(16);

Object.keys(_interface).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _interface[key];
    }
  });
});

var INTERFACE = _interopRequireWildcard(_interface);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

exports['default'] = INTERFACE;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _receive = __webpack_require__(22);

Object.keys(_receive).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _receive[key];
    }
  });
});

var _send = __webpack_require__(12);

Object.keys(_send).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _send[key];
    }
  });
});

var _listeners = __webpack_require__(11);

Object.keys(_listeners).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _listeners[key];
    }
  });
});

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isSameDomain = isSameDomain;
exports.isActuallySameDomain = isActuallySameDomain;
exports.getOpener = getOpener;
exports.getParent = getParent;
exports.getParents = getParents;
exports.isAncestorParent = isAncestorParent;
exports.getFrames = getFrames;
exports.getAllChildFrames = getAllChildFrames;
exports.getAllFramesInWindow = getAllFramesInWindow;
exports.getTop = getTop;
exports.isWindowClosed = isWindowClosed;
exports.getUserAgent = getUserAgent;
exports.getFrameByName = getFrameByName;
exports.findChildFrameByName = findChildFrameByName;
exports.findFrameByName = findFrameByName;
exports.isParent = isParent;
exports.isOpener = isOpener;
exports.getAncestor = getAncestor;
exports.getAncestors = getAncestors;
exports.isAncestor = isAncestor;
exports.isPopup = isPopup;
exports.isIframe = isIframe;
exports.isFullpage = isFullpage;
exports.getWindowType = getWindowType;
exports.isSameTopWindow = isSameTopWindow;
exports.jsonStringify = jsonStringify;
exports.jsonParse = jsonParse;

var _src = __webpack_require__(4);

var _util = __webpack_require__(3);

var _global = __webpack_require__(1);

var _conf = __webpack_require__(0);

_global.global.domainMatches = _global.global.domainMatches || new _src.WeakMap();

var domainMatchTimeout = void 0;

function isSameDomain(win) {

    if (_global.global.domainMatches.has(win)) {
        return _global.global.domainMatches.get(win);
    }

    var match = void 0;

    try {
        if ((0, _util.getDomain)(window) === (0, _util.getDomain)(win)) {
            match = true;
        } else {
            match = false;
        }
    } catch (err) {
        match = false;
    }

    _global.global.domainMatches.set(win, match);

    if (!domainMatchTimeout) {
        domainMatchTimeout = setTimeout(function () {
            _global.global.domainMatches = new _src.WeakMap();
            domainMatchTimeout = null;
        }, 1);
    }

    return match;
}

function isActuallySameDomain(win) {

    try {
        if (win && win.location && win.location.href) {
            return true;
        }
    } catch (err) {
        _global.global.domainMatches.push({ win: win, match: false });
        return false;
    }

    return true;
}

function getOpener(win) {

    if (!win) {
        return;
    }

    try {
        return win.opener;
    } catch (err) {
        return;
    }
}

function getParent(win) {

    if (!win) {
        return;
    }

    try {
        if (win.parent && win.parent !== win) {
            return win.parent;
        }
    } catch (err) {
        return;
    }
}

function getParents(win) {

    var result = [];

    try {

        while (win.parent !== win) {
            result.push(win.parent);
            win = win.parent;
        }
    } catch (err) {
        // pass
    }

    return result;
}

function isAncestorParent(parent, child) {

    if (!parent || !child) {
        return false;
    }

    var childParent = getParent(child);

    if (childParent) {
        return childParent === parent;
    }

    if (getParents(child).indexOf(parent) !== -1) {
        return true;
    }

    return false;
}

function getFrames(win) {

    var result = [];

    var frames = void 0;

    try {
        frames = win.frames;
    } catch (err) {
        frames = win;
    }

    var len = void 0;

    try {
        len = frames.length;
    } catch (err) {
        // pass
    }

    if (len === 0) {
        return result;
    }

    if (len) {
        for (var i = 0; i < len; i++) {

            var frame = void 0;

            try {
                frame = frames[i];
            } catch (err) {
                continue;
            }

            result.push(frame);
        }

        return result;
    }

    for (var _i = 0; _i < 100; _i++) {
        var _frame = void 0;

        try {
            _frame = frames[_i];
        } catch (err) {
            return result;
        }

        if (!_frame) {
            return result;
        }

        result.push(_frame);
    }

    return result;
}

function getAllChildFrames(win) {

    var result = [];

    for (var _iterator = getFrames(win), _isArray = Array.isArray(_iterator), _i2 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i2 >= _iterator.length) break;
            _ref = _iterator[_i2++];
        } else {
            _i2 = _iterator.next();
            if (_i2.done) break;
            _ref = _i2.value;
        }

        var frame = _ref;

        result.push(frame);

        for (var _iterator2 = getAllChildFrames(frame), _isArray2 = Array.isArray(_iterator2), _i3 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref2;

            if (_isArray2) {
                if (_i3 >= _iterator2.length) break;
                _ref2 = _iterator2[_i3++];
            } else {
                _i3 = _iterator2.next();
                if (_i3.done) break;
                _ref2 = _i3.value;
            }

            var childFrame = _ref2;

            result.push(childFrame);
        }
    }

    return result;
}

function getAllFramesInWindow(win) {

    var result = getAllChildFrames(win);

    result.push(win);

    for (var _iterator3 = getParents(win), _isArray3 = Array.isArray(_iterator3), _i4 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
        var _ref3;

        if (_isArray3) {
            if (_i4 >= _iterator3.length) break;
            _ref3 = _iterator3[_i4++];
        } else {
            _i4 = _iterator3.next();
            if (_i4.done) break;
            _ref3 = _i4.value;
        }

        var parent = _ref3;


        result.push(parent);

        for (var _iterator4 = getFrames(parent), _isArray4 = Array.isArray(_iterator4), _i5 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
            var _ref4;

            if (_isArray4) {
                if (_i5 >= _iterator4.length) break;
                _ref4 = _iterator4[_i5++];
            } else {
                _i5 = _iterator4.next();
                if (_i5.done) break;
                _ref4 = _i5.value;
            }

            var frame = _ref4;


            if (result.indexOf(frame) === -1) {
                result.push(frame);
            }
        }
    }

    return result;
}

function getTop(win) {

    if (!win) {
        return;
    }

    try {
        if (win.top) {
            return win.top;
        }
    } catch (err) {
        // pass
    }

    if (getParent(win) === win) {
        return win;
    }

    try {
        if (isAncestorParent(window, win)) {
            return window.top;
        }
    } catch (err) {
        // pass
    }

    try {
        if (isAncestorParent(win, window)) {
            return window.top;
        }
    } catch (err) {
        // pass
    }

    for (var _iterator5 = getAllChildFrames(win), _isArray5 = Array.isArray(_iterator5), _i6 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
        var _ref5;

        if (_isArray5) {
            if (_i6 >= _iterator5.length) break;
            _ref5 = _iterator5[_i6++];
        } else {
            _i6 = _iterator5.next();
            if (_i6.done) break;
            _ref5 = _i6.value;
        }

        var frame = _ref5;

        try {
            if (frame.top) {
                return frame.top;
            }
        } catch (err) {
            // pass
        }

        if (getParent(frame) === frame) {
            return frame;
        }
    }
}

function isWindowClosed(win) {
    var allowMock = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


    try {
        if (win === window) {
            return false;
        }
    } catch (err) {
        return true;
    }

    try {
        if (!win) {
            return true;
        }
    } catch (err) {
        return true;
    }

    try {
        if (win.closed) {
            return true;
        }
    } catch (err) {

        // I love you so much IE

        if (err && err.message === 'Call was rejected by callee.\r\n') {
            return false;
        }

        return true;
    }

    if (allowMock && isSameDomain(win) && (0, _util.safeGet)(win, 'mockclosed')) {
        return true;
    }

    /*
     // IE9... don't even ask. If an iframe is removed from the parent page, .closed does not get set to true
     try {
        if (win.parent === win && !getOpener(win) && win !== getTop(window)) {
            // return true;
        }
    } catch (err) {
        // pass
    }
     */

    return false;
}

function getUserAgent(win) {
    win = win || window;
    return win.navigator.mockUserAgent || win.navigator.userAgent;
}

function getFrameByName(win, name) {

    var winFrames = getFrames(win);

    for (var _iterator6 = winFrames, _isArray6 = Array.isArray(_iterator6), _i7 = 0, _iterator6 = _isArray6 ? _iterator6 : _iterator6[Symbol.iterator]();;) {
        var _ref6;

        if (_isArray6) {
            if (_i7 >= _iterator6.length) break;
            _ref6 = _iterator6[_i7++];
        } else {
            _i7 = _iterator6.next();
            if (_i7.done) break;
            _ref6 = _i7.value;
        }

        var childFrame = _ref6;

        try {
            if (isSameDomain(childFrame) && childFrame.name === name && winFrames.indexOf(childFrame) !== -1) {
                return childFrame;
            }
        } catch (err) {
            // pass
        }
    }

    try {
        if (winFrames.indexOf(win.frames[name]) !== -1) {
            return win.frames[name];
        }
    } catch (err) {
        // pass
    }

    try {
        if (winFrames.indexOf(win[name]) !== -1) {
            return win[name];
        }
    } catch (err) {
        // pass
    }
}

function findChildFrameByName(win, name) {

    var frame = getFrameByName(win, name);

    if (frame) {
        return frame;
    }

    for (var _iterator7 = getFrames(win), _isArray7 = Array.isArray(_iterator7), _i8 = 0, _iterator7 = _isArray7 ? _iterator7 : _iterator7[Symbol.iterator]();;) {
        var _ref7;

        if (_isArray7) {
            if (_i8 >= _iterator7.length) break;
            _ref7 = _iterator7[_i8++];
        } else {
            _i8 = _iterator7.next();
            if (_i8.done) break;
            _ref7 = _i8.value;
        }

        var childFrame = _ref7;

        var namedFrame = findChildFrameByName(childFrame, name);

        if (namedFrame) {
            return namedFrame;
        }
    }
}

function findFrameByName(win, name) {

    var frame = void 0;

    frame = getFrameByName(win, name);

    if (frame) {
        return frame;
    }

    return findChildFrameByName(getTop(win), name);
}

function isParent(win, frame) {

    var frameParent = getParent(frame);

    if (frameParent) {
        return frameParent === win;
    }

    for (var _iterator8 = getFrames(win), _isArray8 = Array.isArray(_iterator8), _i9 = 0, _iterator8 = _isArray8 ? _iterator8 : _iterator8[Symbol.iterator]();;) {
        var _ref8;

        if (_isArray8) {
            if (_i9 >= _iterator8.length) break;
            _ref8 = _iterator8[_i9++];
        } else {
            _i9 = _iterator8.next();
            if (_i9.done) break;
            _ref8 = _i9.value;
        }

        var childFrame = _ref8;

        if (childFrame === frame) {
            return true;
        }
    }

    return false;
}

function isOpener(parent, child) {

    return parent === getOpener(child);
}

function getAncestor(win) {
    win = win || window;

    var opener = getOpener(win);

    if (opener) {
        return opener;
    }

    var parent = getParent(win);

    if (parent) {
        return parent;
    }
}

function getAncestors(win) {

    var results = [];

    var ancestor = win;

    while (ancestor) {
        ancestor = getAncestor(ancestor);
        if (ancestor) {
            results.push(ancestor);
        }
    }

    return results;
}

function isAncestor(parent, child) {

    var actualParent = getAncestor(child);

    if (actualParent) {
        if (actualParent === parent) {
            return true;
        }

        return false;
    }

    if (child === parent) {
        return false;
    }

    if (getTop(child) === child) {
        return false;
    }

    for (var _iterator9 = getFrames(parent), _isArray9 = Array.isArray(_iterator9), _i10 = 0, _iterator9 = _isArray9 ? _iterator9 : _iterator9[Symbol.iterator]();;) {
        var _ref9;

        if (_isArray9) {
            if (_i10 >= _iterator9.length) break;
            _ref9 = _iterator9[_i10++];
        } else {
            _i10 = _iterator9.next();
            if (_i10.done) break;
            _ref9 = _i10.value;
        }

        var frame = _ref9;

        if (frame === child) {
            return true;
        }
    }

    return false;
}

function isPopup() {
    return Boolean(getOpener(window));
}

function isIframe() {
    return Boolean(getParent(window));
}

function isFullpage() {
    return Boolean(!isIframe() && !isPopup());
}

function getWindowType() {
    if (isPopup()) {
        return _conf.CONSTANTS.WINDOW_TYPES.POPUP;
    }
    if (isIframe()) {
        return _conf.CONSTANTS.WINDOW_TYPES.IFRAME;
    }
    return _conf.CONSTANTS.WINDOW_TYPES.FULLPAGE;
}

function anyMatch(collection1, collection2) {

    for (var _iterator10 = collection1, _isArray10 = Array.isArray(_iterator10), _i11 = 0, _iterator10 = _isArray10 ? _iterator10 : _iterator10[Symbol.iterator]();;) {
        var _ref10;

        if (_isArray10) {
            if (_i11 >= _iterator10.length) break;
            _ref10 = _iterator10[_i11++];
        } else {
            _i11 = _iterator10.next();
            if (_i11.done) break;
            _ref10 = _i11.value;
        }

        var item1 = _ref10;

        for (var _iterator11 = collection2, _isArray11 = Array.isArray(_iterator11), _i12 = 0, _iterator11 = _isArray11 ? _iterator11 : _iterator11[Symbol.iterator]();;) {
            var _ref11;

            if (_isArray11) {
                if (_i12 >= _iterator11.length) break;
                _ref11 = _iterator11[_i12++];
            } else {
                _i12 = _iterator11.next();
                if (_i12.done) break;
                _ref11 = _i12.value;
            }

            var item2 = _ref11;

            if (item1 === item2) {
                return true;
            }
        }
    }
}

function isSameTopWindow(win1, win2) {

    var top1 = getTop(win1);
    var top2 = getTop(win2);

    try {
        if (top1 && top2) {
            if (top1 === top2) {
                return true;
            }

            return false;
        }
    } catch (err) {
        // pass
    }

    var allFrames1 = getAllFramesInWindow(win1);
    var allFrames2 = getAllFramesInWindow(win2);

    if (anyMatch(allFrames1, allFrames2)) {
        return true;
    }

    var opener1 = getOpener(top1);
    var opener2 = getOpener(top2);

    if (opener1 && anyMatch(getAllFramesInWindow(opener1), allFrames2)) {
        return false;
    }

    if (opener2 && anyMatch(getAllFramesInWindow(opener2), allFrames1)) {
        return false;
    }
}

function jsonStringify() {

    var objectToJSON = void 0;
    var arrayToJSON = void 0;

    try {
        if (JSON.stringify({}) !== '{}') {
            objectToJSON = Object.prototype.toJSON;
            delete Object.prototype.toJSON;
        }

        if (JSON.stringify({}) !== '{}') {
            throw new Error('Can not correctly serialize JSON objects');
        }

        if (JSON.stringify([]) !== '[]') {
            arrayToJSON = Array.prototype.toJSON;
            delete Array.prototype.toJSON;
        }

        if (JSON.stringify([]) !== '[]') {
            throw new Error('Can not correctly serialize JSON objects');
        }
    } catch (err) {
        throw new Error('Can not repair JSON.stringify: ' + err.message);
    }

    var result = JSON.stringify.apply(this, arguments);

    try {
        if (objectToJSON) {
            Object.prototype.toJSON = objectToJSON; // eslint-disable-line
        }

        if (arrayToJSON) {
            Array.prototype.toJSON = arrayToJSON; // eslint-disable-line
        }
    } catch (err) {
        throw new Error('Can not repair JSON.stringify: ' + err.message);
    }

    return result;
}

function jsonParse() {
    return JSON.parse.apply(this, arguments);
}

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Promise = exports.cleanUpWindow = undefined;

var _clean = __webpack_require__(20);

Object.defineProperty(exports, 'cleanUpWindow', {
    enumerable: true,
    get: function get() {
        return _clean.cleanUpWindow;
    }
});
exports.init = init;

var _public = __webpack_require__(29);

Object.keys(_public).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _public[key];
        }
    });
});

var _lib = __webpack_require__(2);

Object.defineProperty(exports, 'Promise', {
    enumerable: true,
    get: function get() {
        return _lib.Promise;
    }
});

var _drivers = __webpack_require__(5);

var _global = __webpack_require__(1);

function init() {

    if (!_global.global.initialized) {
        (0, _drivers.listenForMessages)();

        if (false) {
            require('./bridge').openTunnelToOpener();
        }

        (0, _lib.initOnReady)();
        (0, _lib.listenForMethods)();
    }

    _global.global.initialized = true;
}

init();

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.log = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(3);

var _windows = __webpack_require__(6);

var _conf = __webpack_require__(0);

var LOG_LEVELS = ['debug', 'info', 'warn', 'error'];

if (Function.prototype.bind && window.console && _typeof(console.log) === 'object') {
    ['log', 'info', 'warn', 'error'].forEach(function (method) {
        console[method] = this.bind(console[method], console);
    }, Function.prototype.call);
}

var log = exports.log = {
    clearLogs: function clearLogs() {

        if (window.console && window.console.clear) {
            window.console.clear();
        }

        if (_conf.CONFIG.LOG_TO_PAGE) {
            var container = document.getElementById('postRobotLogs');

            if (container) {
                container.parentNode.removeChild(container);
            }
        }
    },
    writeToPage: function writeToPage(level, args) {
        setTimeout(function () {
            var container = document.getElementById('postRobotLogs');

            if (!container) {
                container = document.createElement('div');
                container.id = 'postRobotLogs';
                container.style.cssText = 'width: 800px; font-family: monospace; white-space: pre-wrap;';
                document.body.appendChild(container);
            }

            var el = document.createElement('div');

            var date = new Date().toString().split(' ')[4];

            var payload = (0, _util.map)(args, function (item) {
                if (typeof item === 'string') {
                    return item;
                }
                if (!item) {
                    return Object.prototype.toString.call(item);
                }
                var json = void 0;
                try {
                    json = (0, _windows.jsonStringify)(item, 0, 2);
                } catch (e) {
                    json = '[object]';
                }

                return '\n\n' + json + '\n\n';
            }).join(' ');

            var msg = date + ' ' + level + ' ' + payload;
            el.innerHTML = msg;

            var color = {
                log: '#ddd',
                warn: 'orange',
                error: 'red',
                info: 'blue',
                debug: '#aaa'
            }[level];

            el.style.cssText = 'margin-top: 10px; color: ' + color + ';';

            if (!container.childNodes.length) {
                container.appendChild(el);
            } else {
                container.insertBefore(el, container.childNodes[0]);
            }
        });
    },
    logLevel: function logLevel(level, args) {
        setTimeout(function () {
            try {
                var logLevel = window.LOG_LEVEL || _conf.CONFIG.LOG_LEVEL;

                if (LOG_LEVELS.indexOf(level) < LOG_LEVELS.indexOf(logLevel)) {
                    return;
                }

                args = Array.prototype.slice.call(args);

                args.unshift('' + window.location.host + window.location.pathname);
                args.unshift('::');
                args.unshift('' + (0, _windows.getWindowType)().toLowerCase());
                args.unshift('[post-robot]');

                if (_conf.CONFIG.LOG_TO_PAGE) {
                    log.writeToPage(level, args);
                }

                if (!window.console) {
                    return;
                }

                if (!window.console[level]) {
                    level = 'log';
                }

                if (!window.console[level]) {
                    return;
                }

                window.console[level].apply(window.console, args);
            } catch (err) {
                // pass
            }
        }, 1);
    },
    debug: function debug() {
        log.logLevel('debug', arguments);
    },
    info: function info() {
        log.logLevel('info', arguments);
    },
    warn: function warn() {
        log.logLevel('warn', arguments);
    },
    error: function error() {
        log.logLevel('error', arguments);
    }
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.patchPromise = patchPromise;

function trycatch(method, successHandler, errorHandler) {

    var isCalled = false;
    var isSuccess = false;
    var isError = false;
    var err = void 0,
        res = void 0;

    function flush() {
        if (isCalled) {
            if (isError) {
                return errorHandler(err);
            } else if (isSuccess) {
                return successHandler(res);
            }
        }
    }

    try {
        method(function (result) {
            res = result;
            isSuccess = true;
            flush();
        }, function (error) {
            err = error;
            isError = true;
            flush();
        });
    } catch (error) {
        return errorHandler(error);
    }

    isCalled = true;
    flush();
}

var possiblyUnhandledPromiseHandlers = [];
var possiblyUnhandledPromises = [];
var possiblyUnhandledPromiseTimeout = void 0;

function addPossiblyUnhandledPromise(promise) {
    possiblyUnhandledPromises.push(promise);
    possiblyUnhandledPromiseTimeout = possiblyUnhandledPromiseTimeout || setTimeout(flushPossiblyUnhandledPromises, 1);
}

function flushPossiblyUnhandledPromises() {

    possiblyUnhandledPromiseTimeout = null;
    var promises = possiblyUnhandledPromises;
    possiblyUnhandledPromises = [];

    var _loop = function _loop(i) {
        var promise = promises[i];

        if (promise.silentReject) {
            return 'continue';
        }

        promise.handlers.push({
            onError: function onError(err) {
                if (promise.silentReject) {
                    return;
                }

                dispatchError(err);
            }
        });

        promise.dispatch();
    };

    for (var i = 0; i < promises.length; i++) {
        var _ret = _loop(i);

        if (_ret === 'continue') continue;
    }
}

var dispatchedErrors = [];

function dispatchError(err) {

    if (dispatchedErrors.indexOf(err) !== -1) {
        return;
    }

    dispatchedErrors.push(err);

    setTimeout(function () {
        throw err;
    }, 1);

    for (var j = 0; j < possiblyUnhandledPromiseHandlers.length; j++) {
        possiblyUnhandledPromiseHandlers[j](err);
    }
}

var toString = {}.toString;

function isPromise(item) {
    try {
        if (!item) {
            return false;
        }

        if (window.Window && item instanceof window.Window) {
            return false;
        }

        if (window.constructor && item instanceof window.constructor) {
            return false;
        }

        if (toString) {
            var name = toString.call(item);

            if (name === '[object Window]' || name === '[object global]' || name === '[object DOMWindow]') {
                return false;
            }
        }

        if (item && item.then instanceof Function) {
            return true;
        }
    } catch (err) {
        return false;
    }

    return false;
}

var SyncPromise = exports.SyncPromise = function SyncPromise(handler) {

    this.resolved = false;
    this.rejected = false;

    this.silentReject = false;

    this.handlers = [];

    addPossiblyUnhandledPromise(this);

    if (!handler) {
        return;
    }

    var self = this;

    trycatch(handler, function (res) {
        return self.resolve(res);
    }, function (err) {
        return self.reject(err);
    });
};

SyncPromise.resolve = function SyncPromiseResolve(value) {

    if (isPromise(value)) {
        return value;
    }

    return new SyncPromise().resolve(value);
};

SyncPromise.reject = function SyncPromiseResolve(error) {
    return new SyncPromise().reject(error);
};

SyncPromise.prototype.resolve = function (result) {
    if (this.resolved || this.rejected) {
        return this;
    }

    if (isPromise(result)) {
        throw new Error('Can not resolve promise with another promise');
    }

    this.resolved = true;
    this.value = result;
    this.dispatch();

    return this;
};

SyncPromise.prototype.reject = function (error) {
    if (this.resolved || this.rejected) {
        return this;
    }

    if (isPromise(error)) {
        throw new Error('Can not reject promise with another promise');
    }

    this.rejected = true;
    this.value = error;
    this.dispatch();

    return this;
};

SyncPromise.prototype.asyncReject = function (error) {
    this.silentReject = true;
    this.reject(error);
};

SyncPromise.prototype.dispatch = function () {
    var _this = this;

    if (!this.resolved && !this.rejected) {
        return;
    }

    var _loop2 = function _loop2() {

        var handler = _this.handlers.shift();

        var result = void 0,
            error = void 0;

        try {
            if (_this.resolved) {
                result = handler.onSuccess ? handler.onSuccess(_this.value) : _this.value;
            } else if (_this.rejected) {
                if (handler.onError) {
                    result = handler.onError(_this.value);
                } else {
                    error = _this.value;
                }
            }
        } catch (err) {
            error = err;
        }

        if (result === _this) {
            throw new Error('Can not return a promise from the the then handler of the same promise');
        }

        if (!handler.promise) {
            return 'continue';
        }

        if (error) {
            handler.promise.reject(error);
        } else if (isPromise(result)) {
            result.then(function (res) {
                handler.promise.resolve(res);
            }, function (err) {
                handler.promise.reject(err);
            });
        } else {
            handler.promise.resolve(result);
        }
    };

    while (this.handlers.length) {
        var _ret2 = _loop2();

        if (_ret2 === 'continue') continue;
    }
};

SyncPromise.prototype.then = function (onSuccess, onError) {

    if (onSuccess && typeof onSuccess !== 'function' && !onSuccess.call) {
        throw new Error('Promise.then expected a function for success handler');
    }

    if (onError && typeof onError !== 'function' && !onError.call) {
        throw new Error('Promise.then expected a function for error handler');
    }

    var promise = new SyncPromise(null, this);

    this.handlers.push({
        promise: promise,
        onSuccess: onSuccess,
        onError: onError
    });

    this.silentReject = true;

    this.dispatch();

    return promise;
};

SyncPromise.prototype['catch'] = function (onError) {
    return this.then(null, onError);
};

SyncPromise.prototype['finally'] = function (handler) {
    return this.then(function (result) {
        return SyncPromise['try'](handler).then(function () {
            return result;
        });
    }, function (err) {
        return SyncPromise['try'](handler).then(function () {
            throw err;
        });
    });
};

SyncPromise.all = function (promises) {

    var promise = new SyncPromise();
    var count = promises.length;
    var results = [];

    var _loop3 = function _loop3(i) {

        var prom = isPromise(promises[i]) ? promises[i] : SyncPromise.resolve(promises[i]);

        prom.then(function (result) {
            results[i] = result;
            count -= 1;
            if (count === 0) {
                promise.resolve(results);
            }
        }, function (err) {
            promise.reject(err);
        });
    };

    for (var i = 0; i < promises.length; i++) {
        _loop3(i);
    }

    if (!count) {
        promise.resolve(results);
    }

    return promise;
};

SyncPromise.onPossiblyUnhandledException = function syncPromiseOnPossiblyUnhandledException(handler) {
    possiblyUnhandledPromiseHandlers.push(handler);
};

SyncPromise['try'] = function syncPromiseTry(method) {
    return SyncPromise.resolve().then(method);
};

SyncPromise.delay = function syncPromiseDelay(delay) {
    return new SyncPromise(function (resolve) {
        setTimeout(resolve, delay);
    });
};

SyncPromise.hash = function (obj) {

    var results = {};
    var promises = [];

    var _loop4 = function _loop4(key) {
        if (obj.hasOwnProperty(key)) {
            promises.push(SyncPromise.resolve(obj[key]).then(function (result) {
                results[key] = result;
            }));
        }
    };

    for (var key in obj) {
        _loop4(key);
    }

    return SyncPromise.all(promises).then(function () {
        return results;
    });
};

SyncPromise.promisifyCall = function () {

    var args = Array.prototype.slice.call(arguments);
    var method = args.shift();

    if (typeof method !== 'function') {
        throw new Error('Expected promisifyCall to be called with a function');
    }

    return new SyncPromise(function (resolve, reject) {

        args.push(function (err, result) {
            return err ? reject(err) : resolve(result);
        });

        return method.apply(null, args);
    });
};

function patchPromise() {
    window.Promise = SyncPromise;
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var CONSTANTS = exports.CONSTANTS = {

    POST_MESSAGE_TYPE: {
        REQUEST: 'postrobot_message_request',
        RESPONSE: 'postrobot_message_response',
        ACK: 'postrobot_message_ack'
    },

    POST_MESSAGE_ACK: {
        SUCCESS: 'success',
        ERROR: 'error'
    },

    POST_MESSAGE_NAMES: {
        METHOD: 'postrobot_method',
        READY: 'postrobot_ready',
        OPEN_TUNNEL: 'postrobot_open_tunnel'
    },

    WINDOW_TYPES: {
        FULLPAGE: 'fullpage',
        POPUP: 'popup',
        IFRAME: 'iframe'
    },

    WINDOW_PROPS: {
        POSTROBOT: '__postRobot__'
    },

    SERIALIZATION_TYPES: {
        METHOD: 'postrobot_method',
        ERROR: 'postrobot_error'
    },

    SEND_STRATEGIES: {
        POST_MESSAGE: 'postrobot_post_message',
        BRIDGE: 'postrobot_bridge',
        GLOBAL: 'postrobot_global'
    },

    MOCK_PROTOCOL: 'mock:',
    FILE_PROTOCOL: 'file:',

    BRIDGE_NAME_PREFIX: '__postrobot_bridge__',
    POSTROBOT_PROXY: '__postrobot_proxy__',

    WILDCARD: '*'
};

var POST_MESSAGE_NAMES_LIST = exports.POST_MESSAGE_NAMES_LIST = Object.keys(CONSTANTS.POST_MESSAGE_NAMES).map(function (key) {
    return CONSTANTS.POST_MESSAGE_NAMES[key];
});

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.resetListeners = resetListeners;
exports.addResponseListener = addResponseListener;
exports.getResponseListener = getResponseListener;
exports.deleteResponseListener = deleteResponseListener;
exports.getRequestListener = getRequestListener;
exports.addRequestListener = addRequestListener;

var _src = __webpack_require__(4);

var _global = __webpack_require__(1);

var _lib = __webpack_require__(2);

var _conf = __webpack_require__(0);

function resetListeners() {
    _global.global.responseListeners = {};
    _global.global.requestListeners = {};
}

_global.global.responseListeners = _global.global.responseListeners || {};
_global.global.requestListeners = _global.global.requestListeners || {};
_global.global.WINDOW_WILDCARD = _global.global.WINDOW_WILDCARD || new function WindowWildcard() {/* pass */}();

var __DOMAIN_REGEX__ = '__domain_regex__';

function addResponseListener(hash, listener) {
    _global.global.responseListeners[hash] = listener;
}

function getResponseListener(hash) {
    return _global.global.responseListeners[hash];
}

function deleteResponseListener(hash) {
    delete _global.global.responseListeners[hash];
}

function getRequestListener(qualifiers) {
    var name = qualifiers.name,
        win = qualifiers.win,
        domain = qualifiers.domain;


    if (win === _conf.CONSTANTS.WILDCARD) {
        win = null;
    }

    if (domain === _conf.CONSTANTS.WILDCARD) {
        domain = null;
    }

    if (!name) {
        throw new Error('Name required to get request listener');
    }

    var nameListeners = _global.global.requestListeners[name];

    if (!nameListeners) {
        return;
    }

    var _arr = [win, _global.global.WINDOW_WILDCARD];
    for (var _i = 0; _i < _arr.length; _i++) {
        var winQualifier = _arr[_i];

        var winListeners = winQualifier && nameListeners.get(winQualifier);

        if (!winListeners) {
            continue;
        }

        var _arr2 = [domain, _conf.CONSTANTS.WILDCARD];
        for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
            var domainQualifier = _arr2[_i2];

            if (!domainQualifier) {
                continue;
            }

            domainQualifier = domainQualifier.toString();

            if (winListeners[domainQualifier]) {
                return winListeners[domainQualifier];
            }
        }

        if (winListeners[__DOMAIN_REGEX__]) {
            for (var _iterator = winListeners[__DOMAIN_REGEX__], _isArray = Array.isArray(_iterator), _i3 = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
                var _ref2;

                if (_isArray) {
                    if (_i3 >= _iterator.length) break;
                    _ref2 = _iterator[_i3++];
                } else {
                    _i3 = _iterator.next();
                    if (_i3.done) break;
                    _ref2 = _i3.value;
                }

                var _ref3 = _ref2;
                var regex = _ref3.regex,
                    listener = _ref3.listener;

                if ((0, _lib.matchDomain)(regex, domain)) {
                    return listener;
                }
            }
        }
    }
}

function addRequestListener(qualifiers, listener) {
    var name = qualifiers.name,
        win = qualifiers.win,
        domain = qualifiers.domain;


    if (!name || typeof name !== 'string') {
        throw new Error('Name required to add request listener');
    }

    if (Array.isArray(win)) {
        for (var _iterator2 = win, _isArray2 = Array.isArray(_iterator2), _i4 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
            var _ref4;

            if (_isArray2) {
                if (_i4 >= _iterator2.length) break;
                _ref4 = _iterator2[_i4++];
            } else {
                _i4 = _iterator2.next();
                if (_i4.done) break;
                _ref4 = _i4.value;
            }

            var item = _ref4;

            addRequestListener({ name: name, domain: domain, win: item }, listener);
        }
        return;
    }

    if (Array.isArray(domain)) {
        for (var _iterator3 = domain, _isArray3 = Array.isArray(_iterator3), _i5 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
            var _ref5;

            if (_isArray3) {
                if (_i5 >= _iterator3.length) break;
                _ref5 = _iterator3[_i5++];
            } else {
                _i5 = _iterator3.next();
                if (_i5.done) break;
                _ref5 = _i5.value;
            }

            var _item = _ref5;

            addRequestListener({ name: name, win: win, domain: _item }, listener);
        }
        return;
    }

    var existingListener = getRequestListener(qualifiers);

    if (!win || win === _conf.CONSTANTS.WILDCARD) {
        win = _global.global.WINDOW_WILDCARD;
    }

    domain = domain || _conf.CONSTANTS.WILDCARD;

    if (existingListener) {
        if (win && domain) {
            throw new Error('Request listener already exists for ' + name + ' on domain ' + domain + ' for specified window');
        } else if (win) {
            throw new Error('Request listener already exists for ' + name + ' for specified window');
        } else if (domain) {
            throw new Error('Request listener already exists for ' + name + ' on domain ' + domain);
        } else {
            throw new Error('Request listener already exists for ' + name);
        }
    }

    var requestListeners = _global.global.requestListeners;

    var nameListeners = requestListeners[name];

    if (!nameListeners) {
        nameListeners = new _src.WeakMap();
        requestListeners[name] = nameListeners;
    }

    var winListeners = nameListeners.get(win);

    if (!winListeners) {
        winListeners = {};
        nameListeners.set(win, winListeners);
    }

    var strDomain = domain.toString();

    winListeners[strDomain] = listener;

    var regexListeners = winListeners[__DOMAIN_REGEX__];
    var regexListener = void 0;

    if ((0, _lib.isRegex)(domain)) {

        if (!regexListeners) {
            regexListeners = [];
            winListeners[__DOMAIN_REGEX__] = regexListeners;
        }

        regexListener = { regex: domain, listener: listener };

        regexListeners.push(regexListener);
    }

    return {
        cancel: function cancel() {
            delete winListeners[strDomain];

            if (Object.keys(winListeners).length === 0) {
                nameListeners['delete'](win);
            }

            if (regexListener) {
                regexListeners.splice(regexListeners.indexOf(regexListener, 1));
            }
        }
    };
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.buildMessage = buildMessage;
exports.sendMessage = sendMessage;

var _conf = __webpack_require__(0);

var _lib = __webpack_require__(2);

var _strategies = __webpack_require__(24);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function buildMessage(win, message) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


    var id = (0, _lib.uniqueID)();
    var type = (0, _lib.getWindowType)();
    var sourceDomain = (0, _lib.getDomain)(window);

    return _extends({}, message, options, {
        sourceDomain: sourceDomain,
        id: message.id || id,
        windowType: type
    });
}

function sendMessage(win, message, domain) {
    return _lib.promise.run(function () {

        message = buildMessage(win, message, {
            data: (0, _lib.serializeMethods)(win, domain, message.data),
            domain: domain
        });

        var level = void 0;

        if (_conf.POST_MESSAGE_NAMES_LIST.indexOf(message.name) !== -1 || message.type === _conf.CONSTANTS.POST_MESSAGE_TYPE.ACK) {
            level = 'debug';
        } else if (message.ack === 'error') {
            level = 'error';
        } else {
            level = 'info';
        }

        _lib.log.logLevel(level, ['\n\n\t', '#send', message.type.replace(/^postrobot_message_/, ''), '::', message.name, '::', domain || _conf.CONSTANTS.WILDCARD, '\n\n', message]);

        if (_conf.CONFIG.MOCK_MODE) {
            delete message.target;
            return window[_conf.CONSTANTS.WINDOW_PROPS.POSTROBOT].postMessage({
                origin: (0, _lib.getDomain)(window),
                source: window,
                data: (0, _lib.jsonStringify)(message, 0, 2)
            });
        }

        if (win === window) {
            throw new Error('Attemping to send message to self');
        }

        if ((0, _lib.isWindowClosed)(win)) {
            throw new Error('Window is closed');
        }

        _lib.log.debug('Running send message strategies', message);

        var messages = [];

        var serializedMessage = (0, _lib.jsonStringify)(_defineProperty({}, _conf.CONSTANTS.WINDOW_PROPS.POSTROBOT, message), 0, 2);

        return _lib.promise.map(Object.keys(_strategies.SEND_MESSAGE_STRATEGIES), function (strategyName) {

            return _lib.promise.run(function () {

                if (!_conf.CONFIG.ALLOWED_POST_MESSAGE_METHODS[strategyName]) {
                    throw new Error('Strategy disallowed: ' + strategyName);
                }

                return _strategies.SEND_MESSAGE_STRATEGIES[strategyName](win, serializedMessage, domain);
            }).then(function () {
                messages.push(strategyName + ': success');
                return true;
            }, function (err) {
                messages.push(strategyName + ': ' + (err.stack || err.toString()) + '\n');
                return false;
            });
        }).then(function (results) {

            var success = (0, _lib.some)(results);
            var status = message.type + ' ' + message.name + ' ' + (success ? 'success' : 'error') + ':\n  - ' + messages.join('\n  - ') + '\n';

            _lib.log.debug(status);

            if (!success) {
                throw new Error(status);
            }
        });
    });
}

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.matchDomain = matchDomain;

var _util = __webpack_require__(3);

var _conf = __webpack_require__(0);

function matchDomain(domain, origin) {

    if (typeof domain === 'string') {

        if ((0, _util.isRegex)(origin)) {
            return false;
        }

        if (Array.isArray(origin)) {
            return false;
        }

        return domain === _conf.CONSTANTS.WILDCARD || origin === domain;
    }

    if ((0, _util.isRegex)(domain)) {

        if ((0, _util.isRegex)(origin)) {
            return domain.toString() === origin.toString();
        }

        if (Array.isArray(origin)) {
            return false;
        }

        return origin.match(domain);
    }

    if (Array.isArray(domain)) {

        if ((0, _util.isRegex)(origin)) {
            return false;
        }

        if (Array.isArray(origin)) {
            return JSON.stringify(domain) === JSON.stringify(origin);
        }

        return domain.indexOf(origin) !== -1;
    }

    return false;
}

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.promise = exports.Promise = undefined;

var _promise = __webpack_require__(9);

var _tick = __webpack_require__(15);

var Promise = exports.Promise = _promise.SyncPromise;

var promise = exports.promise = {

    Promise: Promise,

    run: function run(method) {
        return Promise.resolve().then(method);
    },
    nextTick: function nextTick(method) {
        return new Promise(function (resolve, reject) {
            (0, _tick.nextTick)(function () {
                return promise.run(method).then(resolve, reject);
            });
        });
    },
    method: function method(_method) {
        return function promiseWrapper() {
            var _this = this,
                _arguments = arguments;

            return Promise.resolve().then(function () {
                return _method.apply(_this, _arguments);
            });
        };
    },
    nodeify: function nodeify(prom, callback) {
        if (!callback) {
            return prom;
        }
        prom.then(function (result) {
            callback(null, result);
        }, function (err) {
            callback(err);
        });
    },
    deNodeify: function deNodeify(method) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
        }

        return new Promise(function (resolve, reject) {
            try {
                if (args.length < method.length) {
                    return method.apply(undefined, args.concat([function (err, result) {
                        return err ? reject(err) : resolve(result);
                    }]));
                }

                return promise.run(function () {
                    return method.apply(undefined, args);
                }).then(resolve, reject);
            } catch (err) {
                return reject(err);
            }
        });
    },
    map: function map(items, method) {

        var results = [];

        var _loop = function _loop(i) {
            results.push(promise.run(function () {
                return method(items[i]);
            }));
        };

        for (var i = 0; i < items.length; i++) {
            _loop(i);
        }
        return Promise.all(results);
    }
};

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.nextTick = nextTick;

var _util = __webpack_require__(3);

var _conf = __webpack_require__(0);

var tickMessageName = '__nextTick__postRobot__' + (0, _util.uniqueID)();
var queue = [];

window.addEventListener('message', function (event) {
    if (event.data === tickMessageName) {
        var method = queue.shift();
        method.call();
    }
});

function nextTick(method) {
    queue.push(method);
    window.postMessage(tickMessageName, _conf.CONSTANTS.WILDCARD);
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _weakmap = __webpack_require__(19);

Object.defineProperty(exports, 'WeakMap', {
  enumerable: true,
  get: function get() {
    return _weakmap.WeakMap;
  }
});

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hasNativeWeakMap = hasNativeWeakMap;
function hasNativeWeakMap() {

    if (!window.WeakMap) {
        return false;
    }

    if (!window.Object.freeze) {
        return false;
    }

    try {

        var testWeakMap = new window.WeakMap();
        var testKey = {};
        var testValue = '__testvalue__';

        window.Object.freeze(testKey);

        testWeakMap.set(testKey, testValue);

        if (testWeakMap.get(testKey) === testValue) {
            return true;
        }

        return false;
    } catch (err) {

        return false;
    }
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isWindow = isWindow;
exports.isClosedWindow = isClosedWindow;
function isWindow(obj) {

    try {
        if (obj && obj.self === obj) {
            return true;
        }
    } catch (err) {
        // pass
    }

    return false;
}

function isClosedWindow(obj) {

    try {
        if (obj && obj !== window && obj.closed) {
            return true;
        }
    } catch (err) {

        if (err && err.message === 'Call was rejected by callee.\r\n') {
            return false;
        }

        return true;
    }

    return false;
}

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.WeakMap = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _util = __webpack_require__(18);

var _native = __webpack_require__(17);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defineProperty = Object.defineProperty;
var counter = Date.now() % 1e9;

var WeakMap = exports.WeakMap = function () {
    function WeakMap() {
        _classCallCheck(this, WeakMap);

        counter += 1;
        this.name = '__weakmap_' + (Math.random() * 1e9 >>> 0) + '__' + counter; // eslint-disable-line

        if ((0, _native.hasNativeWeakMap)()) {
            try {
                this.weakmap = new window.WeakMap();
            } catch (err) {
                // pass
            }
        }

        this.keys = [];
        this.values = [];
    }

    _createClass(WeakMap, [{
        key: '_cleanupClosedWindows',
        value: function _cleanupClosedWindows() {

            var weakmap = this.weakmap;
            var keys = this.keys;

            for (var i = 0; i < keys.length; i++) {
                var value = keys[i];

                if ((0, _util.isClosedWindow)(value)) {

                    if (weakmap) {
                        try {
                            weakmap['delete'](value);
                        } catch (err) {
                            // pass
                        }
                    }

                    keys.splice(i, 1);
                    this.values.splice(i, 1);

                    i -= 1;
                }
            }
        }
    }, {
        key: 'set',
        value: function set(key, value) {

            if (!key) {
                throw new Error('WeakMap expected key');
            }

            var weakmap = this.weakmap;

            if (weakmap) {
                try {
                    weakmap.set(key, value);
                } catch (err) {
                    delete this.weakmap;
                }
            }

            if ((0, _util.isWindow)(key)) {

                this._cleanupClosedWindows();

                var keys = this.keys;
                var values = this.values;
                var index = keys.indexOf(key);

                if (index === -1) {
                    keys.push(key);
                    values.push(value);
                } else {
                    values[index] = value;
                }
            } else {

                var name = this.name;
                var entry = key[name];

                if (entry && entry[0] === key) {
                    entry[1] = value;
                } else {
                    defineProperty(key, name, {
                        value: [key, value],
                        writable: true
                    });
                }
            }
        }
    }, {
        key: 'get',
        value: function get(key) {

            if (!key) {
                throw new Error('WeakMap expected key');
            }

            var weakmap = this.weakmap;

            if (weakmap) {
                try {
                    if (weakmap.has(key)) {
                        return weakmap.get(key);
                    }
                } catch (err) {
                    delete this.weakmap;
                }
            }

            if ((0, _util.isWindow)(key)) {

                var keys = this.keys;
                var index = keys.indexOf(key);

                if (index === -1) {
                    return;
                }

                return this.values[index];
            } else {

                var entry = key[this.name];

                if (entry && entry[0] === key) {
                    return entry[1];
                }
            }
        }
    }, {
        key: 'delete',
        value: function _delete(key) {

            if (!key) {
                throw new Error('WeakMap expected key');
            }

            var weakmap = this.weakmap;

            if (weakmap) {
                try {
                    weakmap['delete'](key);
                } catch (err) {
                    delete this.weakmap;
                }
            }

            if ((0, _util.isWindow)(key)) {

                this._cleanupClosedWindows();

                var keys = this.keys;
                var index = keys.indexOf(key);

                if (index !== -1) {
                    keys.splice(index, 1);
                    this.values.splice(index, 1);
                }
            } else {

                var entry = key[this.name];

                if (entry && entry[0] === key) {
                    entry[0] = entry[1] = undefined;
                }
            }
        }
    }, {
        key: 'has',
        value: function has(key) {

            if (!key) {
                throw new Error('WeakMap expected key');
            }

            var weakmap = this.weakmap;

            if (weakmap) {
                try {
                    return weakmap.has(key);
                } catch (err) {
                    delete this.weakmap;
                }
            }

            if ((0, _util.isWindow)(key)) {

                this._cleanupClosedWindows();

                return this.keys.indexOf(key) !== -1;
            } else {

                var entry = key[this.name];

                if (entry && entry[0] === key) {
                    return true;
                }

                return false;
            }
        }
    }]);

    return WeakMap;
}();

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cleanUpWindow = cleanUpWindow;

var _global = __webpack_require__(1);

function cleanUpWindow(win) {

    // global.tunnelWindows
    // global.bridges
    // global.popupWindowsByName
    // global.responseListeners
    // global.requestListeners

    var requestPromises = _global.global.requestPromises.get(win);

    if (requestPromises) {
        for (var _iterator = requestPromises, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
            var _ref;

            if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
            } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
            }

            var promise = _ref;

            promise.reject(new Error('Window cleaned up'));
        }
    }

    if (_global.global.popupWindowsByWin) {
        _global.global.popupWindowsByWin['delete'](win);
    }

    if (_global.global.remoteWindows) {
        _global.global.remoteWindows['delete'](win);
    }

    _global.global.requestPromises['delete'](win);
    _global.global.methods['delete'](win);
    _global.global.readyPromises['delete'](win);
    _global.global.domainMatches['delete'](win);
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CONFIG = undefined;

var _ALLOWED_POST_MESSAGE;

var _constants = __webpack_require__(10);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CONFIG = exports.CONFIG = {

    ALLOW_POSTMESSAGE_POPUP:  false ? false : true,

    LOG_LEVEL: 'info',

    BRIDGE_TIMEOUT: 5000,

    ACK_TIMEOUT: 1000,
    RES_TIMEOUT:  false ? 2000 : 10000,

    LOG_TO_PAGE: false,

    MOCK_MODE: false,

    ALLOWED_POST_MESSAGE_METHODS: (_ALLOWED_POST_MESSAGE = {}, _defineProperty(_ALLOWED_POST_MESSAGE, _constants.CONSTANTS.SEND_STRATEGIES.POST_MESSAGE, true), _defineProperty(_ALLOWED_POST_MESSAGE, _constants.CONSTANTS.SEND_STRATEGIES.BRIDGE, true), _defineProperty(_ALLOWED_POST_MESSAGE, _constants.CONSTANTS.SEND_STRATEGIES.GLOBAL, true), _ALLOWED_POST_MESSAGE)
};

if (window.location.href.indexOf(_constants.CONSTANTS.FILE_PROTOCOL) === 0) {
    CONFIG.ALLOW_POSTMESSAGE_POPUP = true;
}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.receiveMessage = receiveMessage;
exports.messageListener = messageListener;
exports.listenForMessages = listenForMessages;

var _conf = __webpack_require__(0);

var _lib = __webpack_require__(2);

var _global = __webpack_require__(1);

var _types = __webpack_require__(23);

_global.global.receivedMessages = _global.global.receivedMessages || [];

function parseMessage(message) {

    try {
        message = (0, _lib.jsonParse)(message);
    } catch (err) {
        return;
    }

    if (!message) {
        return;
    }

    message = message[_conf.CONSTANTS.WINDOW_PROPS.POSTROBOT];

    if (!message) {
        return;
    }

    if (!message.type) {
        return;
    }

    if (!_types.RECEIVE_MESSAGE_TYPES[message.type]) {
        return;
    }

    return message;
}

function receiveMessage(event) {

    if (!window || window.closed) {
        throw new Error('Message recieved in closed window');
    }

    try {
        if (!event.source) {
            return;
        }
    } catch (err) {
        return;
    }

    var source = event.source,
        origin = event.origin,
        data = event.data;


    var message = parseMessage(data);

    if (!message) {
        return;
    }

    if (message.sourceDomain.indexOf(_conf.CONSTANTS.MOCK_PROTOCOL) === 0 || message.sourceDomain.indexOf(_conf.CONSTANTS.FILE_PROTOCOL) === 0) {
        origin = message.sourceDomain;
    }

    if (_global.global.receivedMessages.indexOf(message.id) === -1) {
        _global.global.receivedMessages.push(message.id);
    } else {
        return;
    }

    var level = void 0;

    if (_conf.POST_MESSAGE_NAMES_LIST.indexOf(message.name) !== -1 || message.type === _conf.CONSTANTS.POST_MESSAGE_TYPE.ACK) {
        level = 'debug';
    } else if (message.ack === 'error') {
        level = 'error';
    } else {
        level = 'info';
    }

    _lib.log.logLevel(level, ['\n\n\t', '#receive', message.type.replace(/^postrobot_message_/, ''), '::', message.name, '::', origin, '\n\n', message]);

    if ((0, _lib.isWindowClosed)(source)) {
        return _lib.log.debug('Source window is closed - can not send ' + message.type + ' ' + message.name);
    }

    if (message.data) {
        message.data = (0, _lib.deserializeMethods)(source, origin, message.data);
    }

    _types.RECEIVE_MESSAGE_TYPES[message.type](source, origin, message);
}

function messageListener(event) {

    try {
        event.source; // eslint-disable-line
    } catch (err) {
        return;
    }

    event = {
        source: event.source || event.sourceElement,
        origin: event.origin || event.originalEvent.origin,
        data: event.data
    };

    if (false) {
        try {
            require('../../compat').emulateIERestrictions(event.source, window);
        } catch (err) {
            return;
        }
    }

    receiveMessage(event);
}

function listenForMessages() {
    (0, _lib.listen)(window, 'message', messageListener);
}

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RECEIVE_MESSAGE_TYPES = undefined;

var _RECEIVE_MESSAGE_TYPE;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _conf = __webpack_require__(0);

var _lib = __webpack_require__(2);

var _send = __webpack_require__(12);

var _listeners = __webpack_require__(11);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var RECEIVE_MESSAGE_TYPES = exports.RECEIVE_MESSAGE_TYPES = (_RECEIVE_MESSAGE_TYPE = {}, _defineProperty(_RECEIVE_MESSAGE_TYPE, _conf.CONSTANTS.POST_MESSAGE_TYPE.ACK, function (source, origin, message) {

    var options = (0, _listeners.getResponseListener)(message.hash);

    if (!options) {
        throw new Error('No handler found for post message ack for message: ' + message.name + ' from ' + origin + ' in ' + window.location.protocol + '//' + window.location.host + window.location.pathname);
    }

    if (!(0, _lib.matchDomain)(options.domain, origin)) {
        throw new Error('Ack origin ' + origin + ' does not match domain ' + options.domain);
    }

    options.ack = true;
}), _defineProperty(_RECEIVE_MESSAGE_TYPE, _conf.CONSTANTS.POST_MESSAGE_TYPE.REQUEST, function (source, origin, message) {

    var options = (0, _listeners.getRequestListener)({ name: message.name, win: source, domain: origin });

    function respond(data) {

        if (message.fireAndForget || (0, _lib.isWindowClosed)(source)) {
            return _lib.promise.Promise.resolve();
        }

        return (0, _send.sendMessage)(source, _extends({
            target: message.originalSource,
            hash: message.hash,
            name: message.name
        }, data), origin);
    }

    return _lib.promise.Promise.all([respond({
        type: _conf.CONSTANTS.POST_MESSAGE_TYPE.ACK
    }), _lib.promise.run(function () {

        if (!options) {
            throw new Error('No handler found for post message: ' + message.name + ' from ' + origin + ' in ' + window.location.protocol + '//' + window.location.host + window.location.pathname);
        }

        if (!(0, _lib.matchDomain)(options.domain, origin)) {
            throw new Error('Request origin ' + origin + ' does not match domain ' + options.domain);
        }

        var data = message.data;

        return _lib.promise.deNodeify(options.handler, { source: source, origin: origin, data: data });
    }).then(function (data) {

        return respond({
            type: _conf.CONSTANTS.POST_MESSAGE_TYPE.RESPONSE,
            ack: _conf.CONSTANTS.POST_MESSAGE_ACK.SUCCESS,
            data: data
        });
    }, function (err) {

        return respond({
            type: _conf.CONSTANTS.POST_MESSAGE_TYPE.RESPONSE,
            ack: _conf.CONSTANTS.POST_MESSAGE_ACK.ERROR,
            error: err.stack ? err.message + '\n' + err.stack : err.toString()
        });
    })])['catch'](function (err) {

        if (options && options.handleError) {
            return options.handleError(err);
        } else {
            _lib.log.error(err.stack || err.toString());
        }
    });
}), _defineProperty(_RECEIVE_MESSAGE_TYPE, _conf.CONSTANTS.POST_MESSAGE_TYPE.RESPONSE, function (source, origin, message) {

    var options = (0, _listeners.getResponseListener)(message.hash);

    if (!options) {
        throw new Error('No handler found for post message response for message: ' + message.name + ' from ' + origin + ' in ' + window.location.protocol + '//' + window.location.host + window.location.pathname);
    }

    if (!(0, _lib.matchDomain)(options.domain, origin)) {
        throw new Error('Response origin ' + origin + ' does not match domain ' + options.domain);
    }

    (0, _listeners.deleteResponseListener)(message.hash);

    if (message.ack === _conf.CONSTANTS.POST_MESSAGE_ACK.ERROR) {
        return options.respond(new Error(message.error));
    } else if (message.ack === _conf.CONSTANTS.POST_MESSAGE_ACK.SUCCESS) {
        var data = message.data || message.response;

        return options.respond(null, { source: source, origin: origin, data: data });
    }
}), _RECEIVE_MESSAGE_TYPE);

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SEND_MESSAGE_STRATEGIES = undefined;

var _conf = __webpack_require__(0);

var _lib = __webpack_require__(2);

var SEND_MESSAGE_STRATEGIES = exports.SEND_MESSAGE_STRATEGIES = {};

SEND_MESSAGE_STRATEGIES[_conf.CONSTANTS.SEND_STRATEGIES.POST_MESSAGE] = function (win, serializedMessage, domain) {

    if (false) {
        try {
            require('../../compat').emulateIERestrictions(window, win);
        } catch (err) {
            return;
        }
    }

    var domains = void 0;

    if (Array.isArray(domain)) {
        domains = domain;
    } else if (domain) {
        domains = [domain];
    } else {
        domains = [_conf.CONSTANTS.WILDCARD];
    }

    domains = domains.map(function (dom) {

        if (dom.indexOf(_conf.CONSTANTS.MOCK_PROTOCOL) === 0) {

            if (window.location.protocol === _conf.CONSTANTS.FILE_PROTOCOL) {
                return _conf.CONSTANTS.WILDCARD;
            }

            if (!(0, _lib.isActuallySameDomain)(win)) {
                throw new Error('Attempting to send messsage to mock domain ' + dom + ', but window is actually cross-domain');
            }

            return (0, _lib.getActualDomain)(win);
        }

        if (dom.indexOf(_conf.CONSTANTS.FILE_PROTOCOL) === 0) {
            return _conf.CONSTANTS.WILDCARD;
        }

        return dom;
    });

    domains.forEach(function (dom) {
        return win.postMessage(serializedMessage, dom);
    });
};

if (false) {

    var sendBridgeMessage = require('../../bridge').sendBridgeMessage;

    SEND_MESSAGE_STRATEGIES[_conf.CONSTANTS.SEND_STRATEGIES.BRIDGE] = function (win, serializedMessage, domain) {

        if ((0, _lib.isSameDomain)(win)) {
            throw new Error('Post message through bridge disabled between same domain windows');
        }

        if ((0, _lib.isSameTopWindow)(window, win) !== false) {
            throw new Error('Can only use bridge to communicate between two different windows, not between frames');
        }

        return sendBridgeMessage(win, serializedMessage, domain);
    };

    SEND_MESSAGE_STRATEGIES[_conf.CONSTANTS.SEND_STRATEGIES.GLOBAL] = function (win, serializedMessage, domain) {

        if (!(0, _lib.isSameDomain)(win)) {
            throw new Error('Post message through global disabled between different domain windows');
        }

        if ((0, _lib.isSameTopWindow)(window, win) !== false) {
            throw new Error('Can only use global to communicate between two different windows, not between frames');
        }

        var foreignGlobal = win[_conf.CONSTANTS.WINDOW_PROPS.POSTROBOT];

        if (!foreignGlobal) {
            throw new Error('Can not find postRobot global on foreign window');
        }

        return foreignGlobal.receiveMessage({
            source: window,
            origin: (0, _lib.getDomain)(),
            data: serializedMessage
        });
    };
}

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.listenForMethods = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.serializeMethod = serializeMethod;
exports.serializeMethods = serializeMethods;
exports.deserializeMethod = deserializeMethod;
exports.deserializeError = deserializeError;
exports.deserializeMethods = deserializeMethods;

var _src = __webpack_require__(4);

var _conf = __webpack_require__(0);

var _util = __webpack_require__(3);

var _domain = __webpack_require__(13);

var _interface = __webpack_require__(7);

var _log = __webpack_require__(8);

var _promise = __webpack_require__(14);

var _global = __webpack_require__(1);

_global.global.methods = _global.global.methods || new _src.WeakMap();

var listenForMethods = exports.listenForMethods = (0, _util.once)(function () {
    (0, _interface.on)(_conf.CONSTANTS.POST_MESSAGE_NAMES.METHOD, { window: _conf.CONSTANTS.WILDCARD, origin: _conf.CONSTANTS.WILDCARD }, function (_ref) {
        var source = _ref.source,
            origin = _ref.origin,
            data = _ref.data;


        var methods = _global.global.methods.get(source);

        if (!methods) {
            throw new Error('Could not find any methods this window has privileges to call');
        }

        var meth = methods[data.id];

        if (!meth) {
            throw new Error('Could not find method with id: ' + data.id);
        }

        if (!(0, _domain.matchDomain)(meth.domain, origin)) {
            throw new Error('Method domain ' + meth.domain + ' does not match origin ' + origin);
        }

        _log.log.debug('Call local method', data.name, data.args);

        return _promise.promise.run(function () {
            return meth.method.apply({ source: source, origin: origin, data: data }, data.args);
        }).then(function (result) {

            return {
                result: result,
                id: data.id,
                name: data.name
            };
        });
    });
});

function isSerialized(item, type) {
    return (typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object' && item !== null && item.__type__ === type;
}

function serializeMethod(destination, domain, method, name) {

    var id = (0, _util.uniqueID)();

    var methods = _global.global.methods.get(destination);

    if (!methods) {
        methods = {};
        _global.global.methods.set(destination, methods);
    }

    methods[id] = { domain: domain, method: method };

    return {
        __type__: _conf.CONSTANTS.SERIALIZATION_TYPES.METHOD,
        __id__: id,
        __name__: name
    };
}

function serializeError(err) {
    return {
        __type__: _conf.CONSTANTS.SERIALIZATION_TYPES.ERROR,
        __message__: err.stack || err.message || err.toString()
    };
}

function serializeMethods(destination, domain, obj) {

    return (0, _util.replaceObject)({ obj: obj }, function (item, key) {
        if (typeof item === 'function') {
            return serializeMethod(destination, domain, item, key);
        }

        if (item instanceof Error) {
            return serializeError(item);
        }
    }).obj;
}

function deserializeMethod(source, origin, obj) {

    function wrapper() {
        var args = Array.prototype.slice.call(arguments);
        _log.log.debug('Call foreign method', obj.__name__, args);
        return (0, _interface.send)(source, _conf.CONSTANTS.POST_MESSAGE_NAMES.METHOD, {
            id: obj.__id__,
            name: obj.__name__,
            args: args

        }, { domain: origin, timeout: Infinity }).then(function (_ref2) {
            var data = _ref2.data;


            _log.log.debug('Got foreign method result', obj.__name__, data.result);
            return data.result;
        }, function (err) {
            _log.log.debug('Got foreign method error', err.stack || err.toString());
            throw err;
        });
    }

    wrapper.__name__ = obj.__name__;
    wrapper.source = source;
    wrapper.origin = origin;

    return wrapper;
}

function deserializeError(source, origin, obj) {
    return new Error(obj.__message__);
}

function deserializeMethods(source, origin, obj) {

    return (0, _util.replaceObject)({ obj: obj }, function (item, key) {

        if (isSerialized(item, _conf.CONSTANTS.SERIALIZATION_TYPES.METHOD)) {
            return deserializeMethod(source, origin, item);
        }

        if (isSerialized(item, _conf.CONSTANTS.SERIALIZATION_TYPES.ERROR)) {
            return deserializeError(source, origin, item);
        }
    }).obj;
}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initOnReady = initOnReady;
exports.onWindowReady = onWindowReady;

var _src = __webpack_require__(4);

var _conf = __webpack_require__(0);

var _windows = __webpack_require__(6);

var _interface = __webpack_require__(7);

var _log = __webpack_require__(8);

var _promise = __webpack_require__(9);

var _global = __webpack_require__(1);

_global.global.readyPromises = _global.global.readyPromises || new _src.WeakMap();

function initOnReady() {

    (0, _interface.on)(_conf.CONSTANTS.POST_MESSAGE_NAMES.READY, { window: _conf.CONSTANTS.WILDCARD, domain: _conf.CONSTANTS.WILDCARD }, function (event) {

        var win = event.source;
        var promise = _global.global.readyPromises.get(win);

        if (promise) {
            promise.resolve(event);
        } else {
            promise = new _promise.SyncPromise().resolve(event);
            _global.global.readyPromises.set(win, promise);
        }
    });

    var parent = (0, _windows.getAncestor)();

    if (parent) {
        (0, _interface.send)(parent, _conf.CONSTANTS.POST_MESSAGE_NAMES.READY, {}, { domain: _conf.CONSTANTS.WILDCARD, timeout: Infinity })['catch'](function (err) {
            _log.log.debug(err.stack || err.toString());
        });
    }
}

function onWindowReady(win) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
    var name = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Window';


    var promise = _global.global.readyPromises.get(win);

    if (promise) {
        return promise;
    }

    promise = new _promise.SyncPromise();
    _global.global.readyPromises.set(win, promise);
    setTimeout(function () {
        return promise.reject(new Error(name + ' did not load after ' + timeout + 'ms'));
    }, timeout);

    return promise;
}

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.send = undefined;
exports.request = request;
exports.sendToParent = sendToParent;
exports.client = client;

var _src = __webpack_require__(4);

var _conf = __webpack_require__(0);

var _drivers = __webpack_require__(5);

var _lib = __webpack_require__(2);

var _global = __webpack_require__(1);

_global.global.requestPromises = _global.global.requestPromises || new _src.WeakMap();

function request(options) {

    var prom = _lib.promise.run(function () {

        if (!options.name) {
            throw new Error('Expected options.name');
        }

        if (_conf.CONFIG.MOCK_MODE) {
            options.window = window;
        } else if (typeof options.window === 'string') {
            var el = document.getElementById(options.window);

            if (!el) {
                throw new Error('Expected options.window ' + options.window + ' to be a valid element id');
            }

            if (el.tagName.toLowerCase() !== 'iframe') {
                throw new Error('Expected options.window ' + options.window + ' to be an iframe');
            }

            if (!el.contentWindow) {
                throw new Error('Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.');
            }

            options.window = el.contentWindow;
        } else if (options.window instanceof HTMLElement) {

            if (options.window.tagName.toLowerCase() !== 'iframe') {
                throw new Error('Expected options.window ' + options.window + ' to be an iframe');
            }

            if (!options.window.contentWindow) {
                throw new Error('Iframe must have contentWindow.  Make sure it has a src attribute and is in the DOM.');
            }

            options.window = options.window.contentWindow;
        }

        if (!options.window) {
            throw new Error('Expected options.window to be a window object, iframe, or iframe element id.');
        }

        options.domain = options.domain || _conf.CONSTANTS.WILDCARD;

        var hash = options.name + '_' + (0, _lib.uniqueID)();
        (0, _drivers.addResponseListener)(hash, options);

        if ((0, _lib.isWindowClosed)(options.window)) {
            throw new Error('Target window is closed');
        }

        var hasResult = false;

        var requestPromises = _global.global.requestPromises.get(options.window);

        if (!requestPromises) {
            requestPromises = [];
            _global.global.requestPromises.set(options.window, requestPromises);
        }

        var requestPromise = _lib.promise.run(function () {

            if ((0, _lib.isAncestor)(window, options.window)) {
                return (0, _lib.onWindowReady)(options.window);
            }
        }).then(function () {

            return new _lib.promise.Promise(function (resolve, reject) {

                options.respond = function (err, result) {

                    if (!err) {
                        hasResult = true;
                        requestPromises.splice(requestPromises.indexOf(requestPromise, 1));
                    }

                    return err ? reject(err) : resolve(result);
                };

                (0, _drivers.sendMessage)(options.window, {
                    hash: hash,
                    type: _conf.CONSTANTS.POST_MESSAGE_TYPE.REQUEST,
                    name: options.name,
                    data: options.data,
                    fireAndForget: options.fireAndForget
                }, options.domain)['catch'](reject);

                if (options.fireAndForget) {
                    return resolve();
                }

                var ackTimeout = _conf.CONFIG.ACK_TIMEOUT;
                var resTimeout = options.timeout || _conf.CONFIG.RES_TIMEOUT;

                var interval = (0, _lib.safeInterval)(function () {

                    if (options.ack && hasResult) {
                        return interval.cancel();
                    }

                    if ((0, _lib.isWindowClosed)(options.window)) {
                        interval.cancel();

                        if (!options.ack) {
                            return reject(new Error('Window closed for ' + options.name + ' before ack'));
                        }

                        return reject(new Error('Window closed for ' + options.name + ' before response'));
                    }

                    ackTimeout -= 100;
                    resTimeout -= 100;

                    if (ackTimeout <= 0 && !options.ack) {
                        interval.cancel();
                        return reject(new Error('No ack for postMessage ' + options.name + ' in ' + _conf.CONFIG.ACK_TIMEOUT + 'ms'));
                    }

                    if (resTimeout <= 0 && !hasResult) {
                        interval.cancel();
                        return reject(new Error('No response for postMessage ' + options.name + ' in ' + (options.timeout || _conf.CONFIG.RES_TIMEOUT) + 'ms'));
                    }
                }, 100);
            });
        });

        requestPromise['catch'](function () {
            (0, _drivers.deleteResponseListener)(hash);
        });

        requestPromises.push(requestPromise);

        return requestPromise;
    });

    return _lib.promise.nodeify(prom, options.callback);
}

function _send(window, name, data, options, callback) {

    if (!callback) {
        if (!options && typeof data === 'function') {
            callback = data;
            options = {};
            data = {};
        } else if (typeof options === 'function') {
            callback = options;
            options = {};
        }
    }

    options = options || {};
    options.window = window;
    options.name = name;
    options.data = data;
    options.callback = callback;

    return request(options);
}

exports.send = _send;
function sendToParent(name, data, options, callback) {

    var win = (0, _lib.getAncestor)();

    if (!win) {
        return new _lib.promise.Promise(function (resolve, reject) {
            return reject(new Error('Window does not have a parent'));
        });
    }

    return _send(win, name, data, options, callback);
}

function client() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


    if (!options.window) {
        throw new Error('Expected options.window');
    }

    return {
        send: function send(name, data, callback) {
            return _send(options.window, name, data, options, callback);
        }
    };
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CONSTANTS = exports.CONFIG = undefined;
exports.enableMockMode = enableMockMode;
exports.disableMockMode = disableMockMode;

var _conf = __webpack_require__(0);

Object.defineProperty(exports, 'CONFIG', {
    enumerable: true,
    get: function get() {
        return _conf.CONFIG;
    }
});
Object.defineProperty(exports, 'CONSTANTS', {
    enumerable: true,
    get: function get() {
        return _conf.CONSTANTS;
    }
});
exports.disable = disable;

var _drivers = __webpack_require__(5);

function enableMockMode() {
    _conf.CONFIG.MOCK_MODE = true;
}

function disableMockMode() {
    _conf.CONFIG.MOCK_MODE = false;
}

function disable() {
    delete window[_conf.CONSTANTS.WINDOW_PROPS.POSTROBOT];
    window.removeEventListener('message', _drivers.messageListener);
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.winutil = exports.util = exports.bridge = exports.parent = undefined;

var _client = __webpack_require__(27);

Object.keys(_client).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _client[key];
        }
    });
});

var _server = __webpack_require__(30);

Object.keys(_server).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _server[key];
        }
    });
});

var _config = __webpack_require__(28);

Object.keys(_config).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _config[key];
        }
    });
});

var _util = __webpack_require__(3);

Object.defineProperty(exports, 'util', {
    enumerable: true,
    get: function get() {
        return _util.util;
    }
});

var _windows = __webpack_require__(6);

var windowUtil = _interopRequireWildcard(_windows);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var parent = exports.parent = (0, _windows.getAncestor)();

var bridge = exports.bridge = void 0;

if (false) {
    exports.bridge = bridge = require('../bridge/interface');
}

var winutil = exports.winutil = windowUtil;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.on = undefined;
exports.listen = listen;
exports.once = once;
exports.listener = listener;

var _lib = __webpack_require__(2);

var _drivers = __webpack_require__(5);

var _conf = __webpack_require__(0);

function listen(options) {

    if (!options.name) {
        throw new Error('Expected options.name');
    }

    options.handler = options.handler || _lib.noop;

    options.errorHandler = options.errorHandler || function (err) {
        throw err;
    };

    if (options.source) {
        options.window = options.source;
    }

    options.domain = options.domain || _conf.CONSTANTS.WILDCARD;

    var requestListener = (0, _drivers.addRequestListener)({ name: options.name, win: options.window, domain: options.domain }, options);

    if (options.once) {
        var handler = options.handler;
        options.handler = (0, _lib.once)(function () {
            requestListener.cancel();
            return handler.apply(this, arguments);
        });
    }

    options.handleError = function (err) {
        options.errorHandler(err);
    };

    if (options.window && options.errorOnClose) {
        var interval = (0, _lib.safeInterval)(function () {
            if ((0, _lib.isWindowClosed)(options.window)) {
                interval.cancel();
                options.handleError(new Error('Post message target window is closed'));
            }
        }, 50);
    }

    return {
        cancel: function cancel() {
            requestListener.cancel();
        }
    };
}

function _on(name, options, handler, errorHandler) {

    if (typeof options === 'function') {
        errorHandler = handler;
        handler = options;
        options = {};
    }

    options = options || {};

    options.name = name;
    options.handler = handler || options.handler;
    options.errorHandler = errorHandler || options.errorHandler;

    return listen(options);
}

exports.on = _on;
function once(name, options, handler, errorHandler) {

    if (typeof options === 'function') {
        errorHandler = handler;
        handler = options;
        options = {};
    }

    options = options || {};

    options.name = name;
    options.handler = handler || options.handler;
    options.errorHandler = errorHandler || options.errorHandler;
    options.once = true;

    var prom = new _lib.promise.Promise(function (resolve, reject) {
        options.handler = options.handler || function (event) {
            return resolve(event);
        };
        options.errorHandler = options.errorHandler || reject;
    });

    var myListener = listen(options);

    (0, _lib.extend)(prom, myListener);

    return prom;
}

function listener() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};


    return {
        on: function on(name, handler, errorHandler) {
            return _on(name, options, handler, errorHandler);
        }
    };
}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _interface = __webpack_require__(7);

Object.keys(_interface).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _interface[key];
    }
  });
});

var INTERFACE = _interopRequireWildcard(_interface);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

exports['default'] = INTERFACE;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// post-robot.js